module.exports = __webpack_public_path__ + "static/media/ApplicationStage.a216b2eb.svg";